<template>
    <div>
        <span v-if="float" class="float-label">{{ placeholder }}</span>
        <input
          @keydown.up.prevent="navigation('up')"
          @keydown.down="navigation('down')"
          @keydown.tab="select(value, searched[navigate].key || searched[navigate]['.key'], searched[navigate].value, searched[navigate].dealer || false, searched[navigate].transporter || false)"
          @keyup.enter="select(value, searched[navigate].key || searched[navigate]['.key'], searched[navigate].value, searched[navigate].dealer || false, searched[navigate].transporter || false)"
          class="form-control"
          :disabled="disabled"
          :value="value"
          @blur="leave()" @focus="focus()"
          @input="searchAndEmit($event.target.value)"
          :type="type"
          :title="error"
          :pattern="pattern"
          :placeholder="placeholder"/>
        <div ref="dropdown" v-if="dropdown" class="card dropdown-list" @mouseover="hovering = true" @mouseleave="hovering = false">
          <a
            v-for="(item, index) in searched"
            :data-key="item.key || item['.key']"
            :data-value="item.value"
            @mouseenter="navigate = index"
            @click.self="select(value, $event.target.getAttribute('data-key'), $event.target.getAttribute('data-value'), item.dealer || false, item.transporter || false )"
            class="dropdown-item  px-3 py-1"
            :class="{'navigate': navigate === index}">
            {{item.value || item.name}}
            <!-- <input v-if="multiSelect" class="pull-right ml-3 my-1" type="checkbox"> -->
          </a>
        </div>
    </div>
</template>

<script>
  import _ from 'lodash'
  export default{
    props: {
      type: String,
      placeholder: String,
      pattern: {
        type: String,
        required: false
      },
      value: {
        type: [Number, String],
        required: false
      },
      error: {
        type: String,
        required: false
      },
      originalList: {
        type: Object,
        required: false
      },
      secondList: {
        type: Array,
        required: false
      },
      thirdList: {
        type: Array,
        required: false
      },
      sageOne: {
        type: Array,
        required: false
      },
      disabled: {
        type: Boolean,
        required: false
      },
      float: {
        type: Boolean,
        required: false
      },
      multiSelect: {
        type: Boolean,
        required: false
      }
    },
    data () {
      return {
        searched: [],
        dropdown: false,
        hovering: false,
        key: '',
        navigate: 0
      }
    },
    methods: {
      navigation (direction) {
        if (direction === 'up') {
          if (this.navigate <= 0) return
          --this.navigate
          if (this.navigate >= 9 || this.$refs.dropdown.scrollTop > 0) this.$refs.dropdown.scrollTop = this.$refs.dropdown.scrollTop - 32
        } else {
          if (this.navigate === this.searched.length - 1) return
          ++this.navigate
          if (this.navigate >= 9) this.$refs.dropdown.scrollTop = this.$refs.dropdown.scrollTop + 32
        }
      },
      match: function (regex) {
        regex = regex.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
        let re = new RegExp(regex, 'i')
        return function (element) {
          return re.test(element)
        }
      },
      search: _.debounce(function (regex) {
        if (regex !== '') {
          this.searched = []
          if (this.secondList) {
            this.secondList.forEach((entry) => {
              let newRegex = regex.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
              let re = new RegExp(newRegex, 'i')
              if (re.test(entry.name)) {
                let obj = {}
                obj.key = entry['key']
                obj['.key'] = entry['.key']
                obj.value = entry.name
                // console.log(obj)
                this.searched.push(obj)
                // console.log({attr: this.originalList[attr]})
              }
            })
          }
          if (this.thirdList) {
            this.thirdList.forEach((entry) => {
              let newRegex = regex.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
              let re = new RegExp(newRegex, 'i')
              if (re.test(entry.name)) {
                let obj = {}
                obj['.key'] = entry['.key']
                obj.value = entry.name
                obj.dealer = entry.dealer
                obj.transporter = entry.transporter
                // console.log(obj)
                this.searched.push(obj)
                // console.log({attr: this.originalList[attr]})
              }
            })
          }
          if (this.sageOne) {
            this.sageOne.forEach((entry) => {
              let newRegex = regex.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
              let re = new RegExp(newRegex, 'i')
              if (re.test(entry.A)) {
                let obj = {}
                obj.value = entry.A
                obj.key = entry.B
                // console.log(obj)
                this.searched.push(obj)
                // console.log({attr: this.originalList[attr]})
              }
            })
          }
          for (var attr in this.originalList) {
            let newRegex = regex.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
            let re = new RegExp(newRegex, 'i')
            if (re.test(this.originalList[attr])) {
              let obj = {}
              obj.key = attr
              obj.value = this.originalList[attr]
              // console.log(obj)
              this.searched.push(obj)
              // console.log({attr: this.originalList[attr]})
            }
          }
          // this.searched = this.originalList.filter(this.match(value));
          this.dropdown = true
        } else {
          this.searched = []
        }
      }, 200),
      select: function (originalVal, key, value, dealer, transporter) {
        this.$emit('input', {originalVal: originalVal, key: key, value: value, dealer: dealer, transporter: transporter})
        if (!this.multiSelect) this.dropdown = false
      },
      searchAndEmit: function (value) {
        this.navigate = 0
        this.search(value)
        this.$emit('input', {key: null, value: value})
      },
      leave: function () {
        setTimeout(() => { this.dropdown = false }, 150)
      },
      focus: function () {
        this.navigate = 0
        if (this.value !== '') this.search(this.value)
      }
    }
  }
</script>

<style scoped>
    .dropdown-list{
        position: absolute;
        z-index: 9001;
        box-shadow: 0px 5px 8px 0 rgba(0,0,0,0.4);
        /*margin-top: -.75rem;*/
        max-height: 300px;
        overflow-y: auto;
        overflow-x: hidden;
        max-width: 400px;
    }
    a{
        cursor: pointer;
    }
    a:active{
        background-color: #fff;
    }
    .float-label{
      position: absolute;
      padding-left: .75rem;
      top: -1.1rem;
    }
    .navigate {
      background-color: #2c2d2f;
      color: white !important;
    }
</style>



// WEBPACK FOOTER //
// regularDatalist.vue?2ef38b95